import WatchlistButtons from '../includes/watchlist-buttons.js';
import SymbolForm from '../includes/symbol-form.js';

function symbolFormCallback(stock) {
	WatchlistButtons.openModal(stock.symbol);
}

export default function () {
	$('.alerts-calendar-trigger-alert-btn').on('click', function(e) {
		e.preventDefault();

		const alert = $(this).closest('.card');
		const data = $(this).data();

		ajax('watchlistStockTriggerRemove', data, function() {
			alert.remove();
		});
	});

	$('.alerts-calendar-signal-alert-btn').on('click', function(e) {
		e.preventDefault();

		const alert = $(this).closest('.card');
		const data = $(this).data();

		ajax('watchlistStockSignalTrigger', { ... data, signal_alert: 0 }, function() {
			alert.remove();
		});
	});

	WatchlistButtons.initModal();
	SymbolForm.setCallback(symbolFormCallback);
}
